<template>
  <div id="app" class="official-app">
    <header-comp
      v-show="$route.path != '/special-column'"
      class="pc-comp"
    ></header-comp>
    <media-header class="mobile-comp"></media-header>
    <transition name="fade">
      <div
        class="pervasive-bag"
        :class="{
          'party-building-bag': $route.query.title == '器检党建',
          'special-column-bag': $route.path == '/special-column'
        }"
      >
        <div class="version-center mt16">
          <!-- <div class="mobile-comp" style="width: 100%; height: 58px"></div> -->
          <keep-alive
            :include="[
              'home',
              'institutionalOverview',
              'officeHall',
              'specialColumn'
            ]"
          >
            <router-view></router-view>
          </keep-alive>
        </div>
        <!-- <friendship-link></friendship-link> -->
      </div>
    </transition>
    <footer-comp></footer-comp>
    <!-- 智能问答浮动按钮 -->
    <div class="qa-float-btn" @click="openQaDialog">
      <img src="./assets/images/ai_qa_icon.png" alt="智能问答" />
    </div>
    <!-- 智能问答弹窗（遮罩层 + iframe） -->
    <div
      v-if="qaDialogVisible"
      class="qa-mask"
      :class="{ 'qa-fullscreen': qaFullscreen }"
      @click.self="closeQaDialog"
    >
      <div class="qa-iframe-box">
        <iframe
          :src="qaChatUrl"
          width="100%"
          height="100%"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import headerComp from './components/header'
import mediaHeader from './components/mobile-page/mediaHeader.vue'
import footerComp from './components/footer'
// import friendshipLink from './components/friendship-link.vue'

export default {
  name: 'app',
  components: {
    headerComp,
    footerComp,
    mediaHeader
  },
  data() {
    return {
      qaDialogVisible: false,
      qaFullscreen: false,
      // mode=anonymous 告知 QA 系统这是匿名访问场景，无需等待 token
      qaChatUrl: `${process.env.VUE_APP_QASYSTEM_ORIGIN}/#/qa-system/qa-chat/index?isIframe=true&mode=anonymous`
    }
  },
  computed: {},
  watch: {},

  methods: {
    openQaDialog() {
      if (this.qaDialogVisible) {
        this.closeQaDialog()
      } else {
        this.qaDialogVisible = true
      }
    },
    closeQaDialog() {
      this.qaDialogVisible = false
      this.qaFullscreen = false
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.qaDialogVisible) {
        this.closeQaDialog()
      }
    },
    handleMessage(event) {
      if (event.data && event.data.type === 'qa-session-ended') {
        this.closeQaDialog()
        this.qaFullscreen = false
      }
      if (event.data && event.data.type === 'qa-fullscreen-enter') {
        this.qaFullscreen = true
      }
      if (event.data && event.data.type === 'qa-fullscreen-exit') {
        this.qaFullscreen = false
      }
    }
  },
  created() {},
  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('message', this.handleMessage)
  }
}
</script>
<style lang="scss" scoped>
@import url(./assets/css/main.scss);
.fade-enter-active,
.fade-leave-avtive {
  animation-name: fadeInUp;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-timing-function: ease-in;
}
@media only screen and (min-width: 768px) {
  .mobile-comp {
    display: none;
  }
  .pc-comp {
    display: block;
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 3px, 0);
  }

  to {
    opacity: 1;
    transform: translateZ(0);
  }
}

/* 智能问答浮动按钮 */
.qa-float-btn {
  position: fixed;
  top: 60%;
  right: 24px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.qa-float-btn:hover {
  transform: scale(1.05);
}

.qa-float-btn img {
  width: 77px;
  height: 156px;
}

.qa-float-btn span {
  margin-top: 4px;
  font-size: 12px;
  color: #14579e;
  font-weight: 600;
}

/* 智能问答遮罩层 + iframe */
.qa-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qa-iframe-box {
  width: 1286px;
  height: 754px;
  background: transparent;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
  transition: width 0.3s ease, height 0.3s ease, border-radius 0.3s ease;
}

.qa-mask.qa-fullscreen .qa-iframe-box {
  width: 100vw;
  height: 100vh;
  border-radius: 0;
  box-shadow: none;
}

.qa-iframe-box iframe {
  display: block;
  border: none;
}

@media screen and (min-width: 769px) and (max-width: 1440px) {
  .qa-iframe-box {
    width: 80vw;
    height: 80vh;
  }
}

@media screen and (max-width: 768px) {
  .qa-float-btn img {
    width: 48px;
    height: 48px;
  }

  .qa-float-btn span {
    font-size: 10px;
  }

  .qa-iframe-box {
    width: 95vw;
    height: 60vh;
  }
}
// 基础背景
.pervasive-bag {
  position: relative;
  background: #fafcff;
  background-position: center bottom;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
}

.party-building-bag {
  background: #fceeeb url(./assets/images/img_6.webp) no-repeat;
  background-position: center bottom;
  background-size: 100% 100%;
}
.special-column-bag {
  background: red url(./assets/images/bg.webp) no-repeat;
  background-size: 100% 100%;
}
@media screen and (max-width: 768px) {
  .pervasive-bag {
    padding-top: 58px;
    background-color: #fafcff;
  }
}
</style>
